/* esm.sh - unhead@3.1.0/utils */
export * from "/*unhead@3.1.0/esnext/utils.mjs";
